import InfoRow from '@/features/settings/components/GeneralInfoRow'
import Section from '@/features/settings/components/GeneralSection'
import ScrollWrapper from '@/features/settings/components/ScrollWrapper'
import Typography from '@/features/ui/typography'
import { useAppSelector } from '@/hooks/redux'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import Constants from 'expo-constants'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const supportPhone = '606 626 207'
const supportEmail = 'podpora@adaptee.cz'

const GeneralPage: FC = () => {
    const licenceName = useAppSelector(authSelectors.licenceName)
    const licenceId = useAppSelector(authSelectors.licenceId)
    const appVersion = Constants.expoConfig?.version ?? '-'
    const { t } = useTranslation()

    return (
        <ScrollWrapper contentContainerStyle={styles.scrollContent}>
            <View style={styles.content}>
                <Typography.Heading variant="h2" style={styles.pageTitle}>
                    {t('settings.general.heading')}
                </Typography.Heading>

                <Section title={t('settings.general.section.licence')}>
                    <InfoRow
                        label={t('settings.general.field.businessName')}
                        value={licenceName ?? ''}
                    />
                    <InfoRow label={t('settings.general.field.licenceId')} value={licenceId} />
                </Section>

                <Section title={t('settings.general.section.support')}>
                    <InfoRow label={t('settings.general.field.phone')} value={supportPhone} />
                    <InfoRow label={t('settings.general.field.email')} value={supportEmail} />
                </Section>

                <Section title={t('settings.general.section.appVersion')}>
                    <InfoRow label={t('settings.general.field.appVersion')} value={appVersion} />
                </Section>
            </View>
        </ScrollWrapper>
    )
}

const styles = StyleSheet.create({
    scrollContent: {
        paddingVertical: 24,
    },
    content: {
        paddingHorizontal: 12,
    },
    pageTitle: {
        marginBottom: 24,
    },
})

export default GeneralPage
